import styled from 'styled-components'

const StyledDetails = styled.div`
  padding: 3rem;
`

export default StyledDetails
